import { render } from "./DummyTabel.vue?vue&type=template&id=63e2b784"
import script from "./DummyTabel.vue?vue&type=script&lang=js"
export * from "./DummyTabel.vue?vue&type=script&lang=js"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__